import i18n from '@/utils/i18n';
import React from 'react';
import { Typography } from '@usepepper/ui/atoms/typography';
import { useTheme } from '@/contexts/theme-context';
import { View } from '@usepepper/sprout-kit-ui';

interface OrderEntryMobileCatalogResultsHeaderProps {
  count: number;
  query: string;
}

export const OrderEntryMobileCatalogResultsHeader: React.FC<
  OrderEntryMobileCatalogResultsHeaderProps
> = ({ count, query }) => {
  const theme = useTheme();

  return (
    <View
      backgroundColor={theme.sk.color.bg.primary.default}
      paddingBottom={theme.sk.spacing.spaceSMedium}
      paddingHorizontal={theme.sk.spacing.spaceMedium}
      paddingTop={theme.sk.spacing.spaceSmall}
    >
      <Typography variant="heading-sm">
        {i18n.t('sales_portal.order_entry.catalog_results_header', {
          count,
          query,
        })}
      </Typography>
    </View>
  );
};
